const dataArrangements = {
  title: 'Detalii Aranjamente Florale',
  description: [
    'Armonie în toate detaliile...',
    'Indiferent de evenimentul pe care îl aveți în minte, echipa noastră dedicată va lucra îndeaproape cu dvs. pentru a crea decorarea florală a viselor dvs.',
    'Echipa Flori Camelia se angajează să creeze compoziții florale care să vă pună în valoare evenimentul special.',
    'Cu experiența noastră în proiectarea a numeroase evenimente, suntem flexibili și plini de resurse în setul nostru de competențe pentru a vă face evenimentul cu adevărat memorabil cu serviciul nostru complet de proiectare.',
  ],
  footerNotes: '<p>Apelați numărul de telefon <a href=\'tel:\'>+373 676 17 827</a> pentru a discuta mai multe detalii sau a stabili o întâlnire.</p>'
};

export default dataArrangements;
